import sedanImg from '@/assets/sedan.png';
import innovaCrystaImg from '@/assets/innova-crysta.png';
import innovaImg from '@/assets/innova.png';
import tempoImg from '@/assets/tempo-traveler.png';
import urbaniaImg from '@/assets/urbania.png';
import touristBusImg from '@/assets/tourist-bus.png';

export interface VehicleDetails {
  duration?: string;
  tariffKm?: string;
  rate?: string;
  extraKm?: string;
  extraHrs?: string;
}

export interface VehiclePackage {
  name: string;
  duration: string;
  tariffKm: string;
  rate: string;
  extraKm: string;
  extraHrs: string;
}

export interface Vehicle {
  id: string;
  name: string;
  image: string;
  seats: string;
  ac: boolean;
  suitable: string;

  details?: VehicleDetails;
  packages?: VehiclePackage[];
}

export const vehicles: Vehicle[] = [
  {
    id: 'sedan',
    name: 'Etios',
    image: sedanImg,
    seats: '4+1',
    ac: true,
    suitable: 'Family / Business',

    packages: [
      {
        name: 'Full Day Package',
        duration: '8 Hours',
        tariffKm: '80',
        rate: '2500',
        extraKm: '18',
        extraHrs: '250'
      },
      {
        name: '4 Hours Package',
        duration: '4 Hours',
        tariffKm: '40',
        rate: '1500',
        extraKm: '22',
        extraHrs: '350'
      }
    ]
  },
  {
    id: 'innova',
    name: 'Toyota Innova',
    image: innovaImg,
    seats: '6-7 Seater',
    ac: true,
    suitable: 'Family / Groups',

    packages: [
      {
        name: 'Full Day Package',
        duration: '8 Hours',
        tariffKm: '80',
        rate: '3500',
        extraKm: '20',
        extraHrs: '300'
      },
      {
        name: '4 Hours Package',
        duration: '4 Hours',
        tariffKm: '40',
        rate: '2200',
        extraKm: '20',
        extraHrs: '300'
      }
    ]
  },
  {
    id: 'innova-crysta',
    name: 'Innova Crysta',
    image: innovaCrystaImg,
    seats: '6-7 Seater',
    ac: true,
    suitable: 'Premium Comfort',

    packages: [
      {
        name: 'Full Day Package',
        duration: '8 Hours',
        tariffKm: '80',
        rate: '4000',
        extraKm: '22',
        extraHrs: '350'
      },
      {
        name: '4 Hours Package',
        duration: '4 Hours',
        tariffKm: '40',
        rate: '2500',
        extraKm: '22',
        extraHrs: '350'
      }
    ]
  },
  {
    id: 'tempo',
    name: 'Tempo Traveler',
    image: tempoImg,
    seats: '10-26 Seater',
    ac: true,
    suitable: 'Large Groups',

  },
  {
    id: 'urbania',
    name: 'Urbania',
    image: urbaniaImg,
    seats: '10-17 Seater',
    ac: true,
    suitable: 'Group Tours',

  },
  {
    id: 'tourist-bus',
    name: 'Tourist Bus',
    image: touristBusImg,
    seats: '40-50 Seater',
    ac: true,
    suitable: 'Large Tours',

  },
];
